import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const RootBox = styled(Box)`
    padding: 48px 100px;
    height: 476px;
`;
